import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { setTitle } from "../../actions"

import Swiper from 'react-id-swiper';
import  './styles/onboardStyles.scss';

import Group65 from './images/group65';
import Group66 from './images/group66';
import Group67 from './images/group67';
import Group68 from './images/group68';
import Group69 from './images/group69';

@connect((store) => {
	return { User: store.User.User, app: store.app, practices: store.practices }
})

class OwnerOnboarding extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			firstTime: false
		}
		this.goNext = this.goNext.bind(this)
		this.swiper = null
	}

	goNext() {
		if (this.swiper) this.swiper.slideNext();
		if(this.swiper.isEnd){
			document.body.classList.toggle('lastSlide');
		}
	}

	checkFirstTime() {

		var url_string = window.location.href;
		var url = new URL(url_string);

		this.setState({
			firstTime:(url.searchParams.has('nav')) ? false : true
		})
	}
	
	componentDidMount() {
		this.checkFirstTime()
		this.toggleClassOnboarding();
	}

	componentWillUnmount(){
		this.toggleClassOnboarding();
		document.body.classList.toggle('lastSlide');
	}

	toggleClassOnboarding(){
		document.body.classList.toggle('onboarding');
	}

	toggleRedirect() {

		var newUrl = '/home';
		var url_string = window.location.href;
		var url = new URL(url_string);

		if(url.searchParams.has('redirect')) {
			newUrl = (url.searchParams.has('redirect')) ? url.searchParams.get('redirect'): '/home';
		}

		return newUrl
	}

	render() {
		const swiperParams = {
			slidesPerView: 1,
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true,
			},
			spaceBetween: 10,
			observer: true,
			observeParents: true,
			noSwiping: true,
			noSwipingClass: 'swiper-slide'
		  }
		return (
			<main id="ownerOnboarding">
				<Swiper {...swiperParams} ref={node => this.swiper = node !== null ? node.swiper : null } >
					<div className="slide slide1">
						<div className="content">
							
							<Group65/>
								<p>
									Log in & Register your practice. 
									Once your practice has been approved <br className="noBreakMobile"/> 
									an admin will send you your unique 
									practice URL.
								</p>
						</div>
					</div>
					<div className="slide slide2">
						<div className="content">
						<Group66/>
							<p>
								You can start by creating patient 
								names. <br className="noBreakMobile"/>  Click on the patient icon and 
								the plus button to add patient names. 
							</p>
						</div>
					</div>
					<div className="slide slide3">
						<div className="content">
						<Group67/>
							<p>
								Click on the user icon and assign yourself <br className="noBreakMobile"/> 
								and other users. (Therapists/Parents).
							</p>
						</div>
					</div>
					<div className="slide slide4">
						<div className="content">
						<Group68/>
							<p>
								Now to connect the users to the correct 
								patient. <br className="noBreakMobile"/> Click on the patient icon, click on the 
								patients name. <br className="noBreakMobile"/>  Then assign a patient , guardian 
								and therapist to each user.
							</p>
						</div>
					</div>
					<div className="slide slide5">
						<div className="content">
						<Group69/>
							<p>
								You as a therapist can then view your patients 
								names in your<br className="noBreakMobile"/>  home page ‑ this is where you 
								add assessments and sessions.
							</p>
						</div>
					</div>
				</Swiper>
				<div className="buttonGroup">
					<div className="skipButton">
						<a href={this.toggleRedirect()}>SKIP</a>
					</div>
					<div className="nextButton">
						<a onClick={this.goNext}>NEXT</a>
					</div>
					{this.state.firstTime ?
					<div className="letsStartButton">
						<a href={this.toggleRedirect()}>LET'S START</a>
					</div>
					:
					<div className="letsStartButton">
						<a href="/home">CLOSE</a>
					</div>
					}
				</div>
			</main> 
		)
	}

}

export default withRouter(OwnerOnboarding)


// WEBPACK FOOTER //
// ./src/components/onboarding/OwnerOnboarding.jsx